/** Shared by localized links and native anchors, including auth redirect bridges. */
export function isCrossAppDestination(href: string): boolean {
  // These landing routes immediately redirect to React; keep their query intact.
  if (/^\/(?:(?:en|es|pt-BR)\/)?(?:signup|login|register|join\/pilot)(?:[?#]|\/?$)/.test(href)) return true;
  if (!/^https?:\/\//i.test(href)) return false;
  try {
    const url = new URL(href);
    const app = new URL(process.env.NEXT_PUBLIC_REACT_WEB_URL || "http://localhost:3000");
    const configuredDocs = process.env.NEXT_PUBLIC_DOCS_BASE_URL || "https://docs.dronejob.ai";
    const docs = new URL(/^https?:\/\//i.test(configuredDocs) ? configuredDocs : `https://${configuredDocs}`);
    // Public docs paths also cover server-only Docs base URL configuration.
    return url.origin === app.origin || url.origin === docs.origin ||
      /^\/docs(?:\/|$)/.test(url.pathname);
  } catch {
    return false;
  }
}

const descriptions: Record<string, string> = {
  en: "Opens in a new tab", es: "Se abre en una pestaña nueva", "pt-BR": "Abre em uma nova aba",
};

export function crossAppLinkProps(href: string, locale?: string) {
  if (!isCrossAppDestination(href)) return {};
  const language = locale || href.match(/(?:^|[\/#])(en|es|pt-BR)(?:[/?#]|$)/)?.[1] || "en";
  return { target: "_blank", rel: "noopener noreferrer", "aria-description": descriptions[language] || descriptions.en } as const;
}
